import _ from "underscore";
import registry from "@patternslib/patternslib/src/core/registry";
import DisplayTemplate from "./templates/display.xml"
import FormTemplate from "./templates/form.xml";
import EditEventTemplate from "./templates/edit_event.xml";
import RecurrenceEditTemplate from "./templates/recurrence_edit.xml";
import OccurrencesTemplate from "./templates/occurrences.xml";
import Base from "@patternslib/patternslib/src/core/base";
import Modal from "@plone/mockup/src/pat/modal/modal";
import utils from "@plone/mockup/src/core/utils";
import { datetime, RRule, RRuleSet, rrulestr } from 'rrule';
import  "./advancedrecurrence.scss";


export default Base.extend({
    name: "advancedrecurrence",
    trigger: ".pat-advancedrecurrence",
    parser: "mockup",
    rule: "",
    count: 0,
    until: "",
    edit_rule: false,
    updated: false,
    manual_dates: [],
    excluded_dates: [],
    occurrences: [],
    custom_occurrences: {},

    defaults: {
        fields: {
            'start': 'form.widgets.IEventBasic.start',
            'end': 'form.widgets.IEventBasic.end',
            'location': 'form.widgets.IEventLocation.location',
            'custom_occurrences': 'form.widgets.IAdvancedEventRecurrence.custom_occurrences',
            'event_format': 'form.widgets.ITCEQEventType.event_location.widgets.event_format',
            'venue': 'form.widgets.ITCEQEventType.event_location.widgets.venue',
            'address': 'form.widgets.ITCEQEventType.event_location.widgets.address',
            'city': 'form.widgets.ITCEQEventType.event_location.widgets.city',
            'zip': 'form.widgets.ITCEQEventType.event_location.widgets.zip',
            'county': 'form.widgets.ITCEQEventType.event_location.widgets.county',
            'link_to_virtual_meeting': 'form.widgets.ITCEQEventType.event_location.widgets.link_to_virtual_meeting',
            'no_link': 'form.widgets.ITCEQEventType.event_location.widgets.no_link:list',
        }
    },

    clearValues: function(){
        let self = this;
        self.rule = "";
        self.count = 0;
        self.until = "";
        self.edit_rule = false;
        self.updated = false;
        self.manual_dates = [];
        self.excluded_dates = [];
        self.occurrences = [];
        self.custom_occurrences = {};
    },

    humanReadableDate: function (dt){
        // Format the date part (e.g., "Wednesday, April 03, 2024")
        const formattedDate = dt.toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: '2-digit',
            timeZone: 'UTC'
        });

        // Format the time part (e.g., "10:00 AM")
        const formattedTime = dt.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,  // Use 12-hour format
            timeZone: 'UTC'
        });

        // Combine both date and time
        const humanReadableDateTime = `${formattedDate} at ${formattedTime}`;
        return humanReadableDateTime;
    },

    generateOccurrences: function () {
        let self = this;
        self.occurrences = [];
        if (self.rule === ""){
            return;
        }
        if (self.rule === 'custom' || self.rule === 'DAILY' ){
            // XXX: We use DAILY with count = 0 when custom dates is selected. This will need to be changed if DAILY frequency is actually needed
        } else {
            if (self.count === 0 && self.until === ''){
                return;
            }
        }

        let freq = RRule.WEEKLY;
        if (self.rule === "MONTHLY" ){
            freq = RRule.MONTHLY;
        }

        let start_date_field = document.querySelector('input[name="' + self.config.fields.start + '"]').value || '';
        if (!start_date_field.endsWith('Z')) {
            start_date_field += 'Z';
        }
        let start_date = new Date(start_date_field);

        let end_date_field = document.querySelector('input[name="' + self.config.fields.end + '"]').value || '';
        if (!end_date_field.endsWith('Z')) {
            end_date_field += 'Z';
        }
        let end_date = new Date(end_date_field);

        let duration = end_date - start_date;

        let conf = {
            freq: freq,
            dtstart: datetime(start_date.getUTCFullYear(), start_date.getUTCMonth() + 1, start_date.getUTCDate(), start_date.getUTCHours(), start_date.getUTCMinutes()),
        }
        const rruleSet = new RRuleSet()
        if (self.count > 0){
            conf['count'] = self.count;
        }

        if (self.until !== ""){
            let until_date = new Date(self.until);
            conf['until'] = datetime(until_date.getUTCFullYear(), until_date.getUTCMonth() + 1, until_date.getUTCDate(), until_date.getUTCHours(), until_date.getUTCMinutes())
        } else if (self.count == 0){
            conf['count'] = self.count;
        }

        // Add a rrule to rruleSet
        rruleSet.rrule(
            new RRule(conf)
        )
        for (let dt of self.manual_dates) {
            let manual_date = new Date(dt);
            rruleSet.rdate(datetime(manual_date.getUTCFullYear(), manual_date.getUTCMonth() + 1, manual_date.getUTCDate(), manual_date.getUTCHours(), manual_date.getUTCMinutes()))
        }
        // XXX: In order to show the occurrence in the UI, we don't add it to the rruleSet
        // for (let dt of self.excluded_dates) {
        //     let excluded_date = new Date(dt);
        //     rruleSet.exdate(datetime(excluded_date.getUTCFullYear(), excluded_date.getUTCMonth() + 1, excluded_date.getUTCDate(), excluded_date.getUTCHours(), excluded_date.getUTCMinutes()))
        // }

        for (let occ of rruleSet.all()){
            let occ_dt = occ.toISOString();
            let ts = occ.getTime();
            let val = null;
            let occ_data = {
                'customized': false,
                'cancelled': false
            };
            if (occ_dt in self.custom_occurrences){
                let custom_occ = self.custom_occurrences[occ_dt];
                if ('cancelled' in custom_occ){
                    occ_data['cancelled'] = custom_occ['cancelled'];
                }
            }
            for (let [key, field_name] of Object.entries(self.options.fields)) {
                if (occ_dt in self.custom_occurrences && key in self.custom_occurrences[occ_dt]){
                    val = self.custom_occurrences[occ_dt][key];
                    if (key === 'start' || key === 'end'){
                        val += ':00.000Z';
                    }
                    occ_data["customized"] = true;
                } else {
                    if (key === 'start'){
                        val = occ_dt;
                    } else if (key === 'end'){
                        let occ_end = new Date(occ.getTime() + duration);
                        val = occ_end.toISOString();
                    } else {
                        if (key === 'event_format') {
                            val = document.querySelector('input[name="' + field_name + '"]:checked')?.value || '';
                        } else {
                            val = document.querySelector('input[name="' + field_name + '"]')?.value || '';
                        }
                    }
                }
                if (key === 'start' || key ==='end'){
                    let dt = new Date(val)
                    occ_data[key+"_hr"] = self.humanReadableDate(dt);
                }
                occ_data[key] = val;
            }
            occ_data["deleted"] = self.excluded_dates.includes(ts);
            occ_data["manually_added"] = self.manual_dates.includes(ts);
            self.occurrences.push(occ_data)
        }

    },

    parseRrule: function () {
        let self = this;
        for (let part of self.el.value.split('\n')) {
            if (part.startsWith("RRULE")){
                let rulePart = part.split(":")[1];  // get the part after "RRULE:"
                // Split by ";" to separate the "FREQ" and "COUNT" parts
                let ruleComponents = rulePart.split(";");
                ruleComponents.forEach(component => {
                    let [key, value] = component.split("=");
                    if (key === "FREQ") {
                        self.rule = value;
                    } else if (key === "COUNT") {
                        self.count = parseInt(value);
                    } else if (key === "UNTIL") {
                        // XXX: The datetime format in UNTIL date is YYYYMMDDT000000.000
                        // so we insert dashes and colons to convert it to ISO 8601 format
                        let formattedDate = value.replace(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2}).(\d{3})$/, '$1-$2-$3T$4:$5:$6.$7Z');
                        self.until = formattedDate;
                    }
                });

            } else if (part.startsWith("RDATE")){
                let rulePart = part.split("RDATE:")[1];  // get the part after "RDATE:"
                let dates = rulePart.split(",");
                dates.forEach(date => {
                    // RDATE from the default widget, can have hours without leading 0
                    // We need the datetime to be in proper ISO 8601 format (ie. YYYY-MM-DDThh:mm:ss)
                    let formattedDate = date.replace(/T(\d{1}):(\d{2}):(\d{2})/, 'T0$1:$2:$3');
                    if (!formattedDate.endsWith('Z')){
                        formattedDate += 'Z';
                    }
                    const dt = new Date(formattedDate);
                    if (isNaN(dt.getTime())) {
                        console.log("Invalid RDATE Date:", date);
                    } else {
                        self.manual_dates.push(dt.getTime());
                    }
                });
            } else if (part.startsWith("EXDATE")){
                let rulePart = part.split("EXDATE:")[1];  // get the part after "EXDATE:"
                let dates = rulePart.split(",");
                dates.forEach(date => {
                    // XXX: The datetime format in EXDATE dates is YYYYMMDDTHHMMSS
                    // so we insert dashes and colons to convert it to ISO 8601 format
                    let formattedDate = date.replace(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})$/, '$1-$2-$3T$4:$5:$6');
                    if (!formattedDate.endsWith('Z')){
                        formattedDate += 'Z';
                    }

                    const dt = new Date(formattedDate);
                    if (isNaN(dt.getTime())) {
                        console.log("Invalid EXDATE Date:", date);
                    } else {
                        self.excluded_dates.push(dt.getTime());
                    }
                });
            }
        }
        let custom_occ_field = document.querySelector('textarea[name="' + self.config.fields.custom_occurrences + '"]').value || '{}';
        try {
            self.custom_occurrences = JSON.parse(custom_occ_field);
        } catch (error) {
            console.error("Error parsing custom occurrences:", error);
            self.custom_occurrences = {};  // Fallback to an empty object if parsing fails
        }

        self.generateOccurrences();
    },

    generateRRule: function (){
        let self = this;
        let rdate_dates = [];
        let exdate_dates = [];

        for (let dt of self.manual_dates) {
            let manual_date = new Date(dt);
            const year = manual_date.getUTCFullYear();
            const month = String(manual_date.getUTCMonth() + 1).padStart(2, '0');  // Months are 0-indexed, so add 1
            const day = String(manual_date.getUTCDate()).padStart(2, '0');
            const hours = String(manual_date.getUTCHours()).padStart(2, '0');
            const minutes = String(manual_date.getUTCMinutes()).padStart(2, '0');
            const seconds = String(manual_date.getSeconds()).padStart(2, '0');

            // Combine into the desired format
            const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
            rdate_dates.push(formattedDate);
        }

        for (let dt of self.excluded_dates) {
            let excluded_date = new Date(dt);
            const year = excluded_date.getUTCFullYear();
            const month = String(excluded_date.getUTCMonth() + 1).padStart(2, '0');  // Months are 0-indexed, so add 1
            const day = String(excluded_date.getUTCDate()).padStart(2, '0');
            const hours = String(excluded_date.getUTCHours()).padStart(2, '0');
            const minutes = String(excluded_date.getUTCMinutes()).padStart(2, '0');
            const seconds = String(excluded_date.getSeconds()).padStart(2, '0');

            // Combine into the desired format
            const formattedDate = `${year}${month}${day}T${hours}${minutes}${seconds}`;
            exdate_dates.push(formattedDate);
        }

        let result = "RRULE:FREQ=" + self.rule;
        if (self.until !== ''){
            let formattedDate = self.until
                                .replace(/-/g, '')  // Remove all dashes
                                .replace(/:/g, '')  // Remove all colons
                                .replace('Z', '');
            result += `;UNTIL=${formattedDate}`;
        } else if (self.count > 0) {
            result += `;COUNT=${self.count}`;
        } else {
            result += ";COUNT=0";
        }

        if (rdate_dates.length) {
            result += `\nRDATE:${rdate_dates.join(",")}`;
        }

        if (exdate_dates.length) {
            result += `\nEXDATE:${exdate_dates.join(",")}`;
        }

        return result;
    },

    addOrEditOccurrence: function (data, should_delete) {
        let self = this;
        const compiled_form = _.template(EditEventTemplate)(data);
        let edit_event_form = document.createElement('div');
        edit_event_form.innerHTML = compiled_form;
        registry.scan(edit_event_form);

        function updateLocationVisibility(selectedValue) {
            const inPersonLocation = edit_event_form.querySelector('.in-person-location');
            const virtualLocation = edit_event_form.querySelector('.virtual-location');

            if (selectedValue === "In Person") {
                inPersonLocation.classList.remove('disabled-overlay');
                virtualLocation.classList.add('disabled-overlay');
            } else if (selectedValue === "Virtual") {
                inPersonLocation.classList.add('disabled-overlay');
                virtualLocation.classList.remove('disabled-overlay');
            } else if (selectedValue === "Both") {
                inPersonLocation.classList.remove('disabled-overlay');
                virtualLocation.classList.remove('disabled-overlay');
            }

            const checkbox = edit_event_form.querySelector("#no-virtual-link");
            const isChecked = checkbox.checked;
            const virtualLinkDiv = virtualLocation.querySelector('#virtual-link-field');
            if (isChecked){
                virtualLinkDiv.classList.add('disabled-overlay');
            } else {
                virtualLinkDiv.classList.remove('disabled-overlay');
            }
        
        }

        function validateStartField(startField) {
            let invalid = false;
            const errorMessage = edit_event_form.querySelector('span#event-error-start');
            if (startField.value === ""){
                invalid = true;
                errorMessage.textContent = "Select a time or date";
            } else {
                const value = startField.value + ':00.000Z';
                if (value){
                    const occurrenceCards = document.querySelectorAll('.occurrences > .occurrence-card');
                    for (let card of occurrenceCards) {
                        const occurrenceStart = card.getAttribute('data-occurrence-start');
                        if (should_delete && data.occurrence !== undefined && data.occurrence === occurrenceStart){
                            continue;
                        }
                        if (value === occurrenceStart) {
                            invalid = true;
                            errorMessage.textContent = "An event with the same start time already exists.";
                            break;
                        }
                    }
                }
            }
            const saveButton = edit_event_form.querySelector('button#event-edit-save');
            if (invalid){
                startField.setCustomValidity("Invalid date.");
                if (saveButton) {
                    saveButton.setAttribute('disabled', '');
                }
            } else {
                startField.setCustomValidity("");
                if (saveButton) {
                    saveButton.removeAttribute('disabled');
                }
            }
        }

        function validateEndField(endField) {
            let invalid = false;
            const errorMessage = edit_event_form.querySelector('span#event-error-end');
            errorMessage.textContent = '';
            if (endField.value === ""){
                invalid = true;
                errorMessage.textContent = "Select a time or date";
            } else {
                const start_field = edit_event_form.querySelector('input[name="event.edit.start"]');

                const startDate = new Date(start_field.value);
                const endDate = new Date(endField.value);

                if (endDate <= startDate){
                    invalid = true;
                    errorMessage.textContent = "The end date must be after the start date.";
                }
            }
            const saveButton = edit_event_form.querySelector('button#event-edit-save');
            if (invalid){
                endField.setCustomValidity("Invalid date.");
                if (saveButton) {
                    saveButton.setAttribute('disabled', '');
                }
            } else {
                endField.setCustomValidity("");
                if (saveButton) {
                    saveButton.removeAttribute('disabled');
                }
            }
        }

        const start_field = edit_event_form.querySelector('input[name="event.edit.start"]');
        const end_field = edit_event_form.querySelector('input[name="event.edit.end"]');

        start_field.addEventListener('change', function() {
            validateStartField(this);
            validateEndField(end_field);
        });
        validateStartField(start_field);

        end_field.addEventListener('change', function() {
            validateEndField(this);
        });
        validateEndField(end_field);

        const selectedValue = edit_event_form.querySelector('input[name="eventFormat"]:checked')?.value || '';
        updateLocationVisibility(selectedValue);

        edit_event_form.querySelectorAll('input[name="eventFormat"]').forEach(function(element) {
            element.addEventListener('change', function(e) {
                updateLocationVisibility(this.value);
            });
        });

        const no_link_checkbox = edit_event_form.querySelector('input[name="no_link"]');
        no_link_checkbox.addEventListener('change', function(e) {
            updateLocationVisibility();
        });

        // Add click event listener for save button
        const saveButton = edit_event_form.querySelector('button#event-edit-save');
        if (saveButton) {
            saveButton.addEventListener('click', function(e) {
                e.stopPropagation();

                // Get occurrence from data attribute
                const eventEditForm = edit_event_form.querySelector('div.event-edit-form');
                let occurrence = eventEditForm?.dataset.occurrence || '';

                // Get start and end times
                const start = edit_event_form.querySelector('input[name="event.edit.start"]')?.value || '';
                const end = edit_event_form.querySelector('input[name="event.edit.end"]')?.value || '';

                // Check if start date changed
                if (occurrence.slice(0, 16) !== start) {
                    let ts = "";
                    if (occurrence !== "") {
                        ts = new Date(occurrence).getTime();
                        const index = self.manual_dates.indexOf(ts);
                        if (index !== -1) {
                            if (should_delete) {
                                self.manual_dates.splice(index, 1);
                            }
                        } else {
                            self.excluded_dates.push(ts);
                        }
                    }
                    // Set occurrence to the new start
                    occurrence = start + ":00.000Z";
                    ts = new Date(occurrence).getTime();
                    self.manual_dates.push(ts);
                }

                // Gather form values
                const event_format = edit_event_form.querySelector('input[name="eventFormat"]:checked')?.value || '';
                const venue = edit_event_form.querySelector('input[name="venue"]')?.value || '';
                const address = edit_event_form.querySelector('input[name="address"]')?.value || '';
                const city = edit_event_form.querySelector('input[name="city"]')?.value || '';
                const zip = edit_event_form.querySelector('input[name="zipcode"]')?.value || '';
                const county = edit_event_form.querySelector('input[name="county"]')?.value || '';
                const link_to_virtual_meeting = edit_event_form.querySelector('input[name="link_to_virtual_meeting"]')?.value || '';
                const no_link = edit_event_form.querySelector('input[name="no_link"]')?.checked || false;

                // Create data object
                const data = {
                    'occurrence': occurrence,
                    'start': start,
                    'end': end,
                    'event_format': event_format,
                    'venue': venue,
                    'address': address,
                    'city': city,
                    'zip': zip,
                    'county': county,
                    'link_to_virtual_meeting': link_to_virtual_meeting,
                    'no_link': no_link
                };

                // Store custom occurrences
                self.custom_occurrences[occurrence] = data;
                self.updateModal();
            });
        }

        // Add click event listener for cancel button
        const cancelButton = edit_event_form.querySelector('button#event-edit-cancel');
        if (cancelButton) {
            cancelButton.addEventListener('click', function(e) {
                e.stopPropagation();
                self.updateModal({ update_occurrences: false });
            });
        }

        return edit_event_form;
    },

    renderOccurrences: function () {
        let self = this;
        const conf = {
            'occurrences': self.occurrences,
            'icons': self.config.icons
        }

        const compiled_form = _.template(OccurrencesTemplate)(conf);
        let occurrences_form = document.createElement('div');
        occurrences_form.innerHTML = compiled_form;

        const cancelButtons = occurrences_form.querySelectorAll('div.occurrence-buttons button.cancel-event');

        cancelButtons.forEach(cancelButton => {
            cancelButton.addEventListener('click', function(e) {
                e.stopPropagation();
                let parent = this.parentElement; // Get the parent element
                let occ = parent.dataset.occurrence; // Use dataset to get the data attribute value

                // TODO: Create modal for confirmation
                if (!(occ in self.custom_occurrences)) {
                    self.custom_occurrences[occ] = {};
                }
                self.custom_occurrences[occ]['cancelled'] = true;
                self.updateModal();
            });
        });

        const uncancelButtons = occurrences_form.querySelectorAll('div.occurrence-buttons button.uncancel-event');

        uncancelButtons.forEach(uncancelButton => {
            uncancelButton.addEventListener('click', function(e) {
                e.stopPropagation(); // Prevent the event from bubbling up
                let parent = this.parentElement; // Get the parent element
                let occ = parent.dataset.occurrence; // Use dataset to get the data attribute value

                // TODO: Create modal for confirmation
                if (!(occ in self.custom_occurrences)) {
                    self.custom_occurrences[occ] = {};
                }
                self.custom_occurrences[occ]['cancelled'] = false; // Set cancelled status to false
                self.updateModal(); // Call the update method
            });
        });

        const deleteButtons = occurrences_form.querySelectorAll('div.occurrence-buttons button.delete-event');

        // Function to reset the buttons if clicked outside
        function resetButtons() {
            deleteButtons.forEach(btn => {
                if (btn.textContent === 'Confirm?') {
                    let parent = btn.parentElement.parentElement;
                    const warningText = parent.querySelector('.delete-warning');
                    warningText.style.display = 'none';

                    btn.textContent = "Delete ";
                    btn.innerHTML = `Delete ${self.config.icons.remove}`
                    // btn.appendChild(self.config.icons.remove);
                    btn.classList.remove('btn-outline-danger');
                    btn.classList.add('btn-danger');
                }
            });
        }

        deleteButtons.forEach(deleteButton => {
            deleteButton.addEventListener('click', function(e) {
                e.stopPropagation();  // Prevent event from bubbling up
                let parent = this.parentElement.parentElement;
                const warningText = parent.querySelector('.delete-warning');
                warningText.style.display = 'none';

                // Check if the button is already in "Confirm?" state
                if (this.textContent === 'Confirm?') {
                    parent = this.parentElement;
                    let occ = parent.dataset.occurrence;
                    let ts = new Date(occ).getTime();

                    // Handle deletion logic
                    if (self.manual_dates.includes(ts)) {
                        self.manual_dates = self.manual_dates.filter(item => item !== ts);
                    } else if (!self.excluded_dates.includes(ts)) {
                        self.excluded_dates.push(ts);
                    }

                    self.updateModal();
                } else {
                    // Change button to "Confirm?" state
                    warningText.style.display = 'block';
                    this.textContent = 'Confirm?';
                    this.classList.remove('btn-danger');
                    this.classList.add('btn-outline-danger');

                    // Set up a one-time event listener to detect click outside the button
                    occurrences_form.addEventListener('click', resetButtons, { once: true });
                }
            });
        });

        const undeleteButtons = occurrences_form.querySelectorAll('div.occurrence-buttons button.undelete-event');

        undeleteButtons.forEach(undeleteButton => {
            undeleteButton.addEventListener('click', function(e) {
                e.stopPropagation(); // Prevent the event from bubbling up
                let parent = this.parentElement; // Get the parent element
                let occ = parent.dataset.occurrence; // Use dataset to get the data attribute value
                let ts = new Date(occ).getTime(); // Convert the occurrence to timestamp

                // Filter out the timestamp from excluded_dates
                self.excluded_dates = self.excluded_dates.filter(item => item !== ts);

                self.updateModal(); // Call the update method
            });
        });

        const editButtons = occurrences_form.querySelectorAll('div.occurrence-buttons button.edit-event');

        editButtons.forEach(editButton => {
            editButton.addEventListener('click', function(e) {
                e.stopPropagation(); // Prevent the event from bubbling up
                let parent = this.parentElement; // Get the parent element
                let occurrence = parent.dataset.occurrence; // Get occurrence from data attribute
                let end_date = parent.dataset.occurrenceEnd; // Get end date from data attribute

                // Use querySelector to get values from input fields
                let event_format = document.querySelector(`input[name="${self.config.fields.event_format}"]:checked`)?.value || '';
                let venue = document.querySelector(`input[name="${self.config.fields.venue}"]`)?.value || '';
                let address = document.querySelector(`input[name="${self.config.fields.address}"]`)?.value || '';
                let city = document.querySelector(`input[name="${self.config.fields.city}"]`)?.value || '';
                let zip = document.querySelector(`input[name="${self.config.fields.zip}"]`)?.value || '';
                let county = document.querySelector(`input[name="${self.config.fields.county}"]`)?.value || '';
                let link_to_virtual_meeting = document.querySelector(`input[name="${self.config.fields.link_to_virtual_meeting}"]`)?.value || '';
                let no_link = document.querySelector(`input[name="${self.config.fields.no_link}"]`)?.checked || false;

                // Create data object for the occurrence
                let data = {
                    'occurrence': occurrence,
                    'start': occurrence.slice(0, 16),
                    'end': end_date.slice(0, 16),
                    'event_format': event_format,
                    'venue': venue,
                    'address': address,
                    'city': city,
                    'zip': zip,
                    'county': county,
                    'link_to_virtual_meeting': link_to_virtual_meeting,
                    'no_link': no_link
                };

                // Check if occurrence exists in custom occurrences
                if (occurrence in self.custom_occurrences) {
                    // Override only the properties that exist in self.custom_occurrences[occurrence]
                    data = Object.assign(data, self.custom_occurrences[occurrence]);
                }

                // Call the addOrEditOccurrence function to get the edit event form
                let edit_event_form = self.addOrEditOccurrence(data, true);
                let occ_card = parent.closest('.occurrence-card');
                occ_card.replaceWith(edit_event_form); // Replace the occurrence card with the edit form

                self.modal.positionModal(); // Position the modal
            });
        });

        const duplicateButtons = occurrences_form.querySelectorAll('div.occurrence-buttons button.duplicate-event');

        duplicateButtons.forEach(duplicateButton => {
            duplicateButton.addEventListener('click', function(e) {
                e.stopPropagation(); // Prevent the event from bubbling up
                let parent = this.parentElement; // Get the parent element
                let occurrence = parent.dataset.occurrence; // Get occurrence from data attribute
                let end_date = parent.dataset.occurrenceEnd; // Get end date from data attribute

                // Use querySelector to get values from input fields
                let event_format = document.querySelector(`input[name="${self.config.fields.event_format}"]:checked`)?.value || '';
                let venue = document.querySelector(`input[name="${self.config.fields.venue}"]`)?.value || '';
                let address = document.querySelector(`input[name="${self.config.fields.address}"]`)?.value || '';
                let city = document.querySelector(`input[name="${self.config.fields.city}"]`)?.value || '';
                let zip = document.querySelector(`input[name="${self.config.fields.zip}"]`)?.value || '';
                let county = document.querySelector(`input[name="${self.config.fields.county}"]`)?.value || '';
                let link_to_virtual_meeting = document.querySelector(`input[name="${self.config.fields.link_to_virtual_meeting}"]`)?.value || '';
                let no_link = document.querySelector(`input[name="${self.config.fields.no_link}"]`)?.checked || false;

                // Create data object for the occurrence
                let data = {
                    'occurrence': occurrence,
                    'start': occurrence.slice(0, 16),
                    'end': end_date.slice(0, 16),
                    'event_format': event_format,
                    'venue': venue,
                    'address': address,
                    'city': city,
                    'zip': zip,
                    'county': county,
                    'link_to_virtual_meeting': link_to_virtual_meeting,
                    'no_link': no_link
                };

                // Check if occurrence exists in custom occurrences
                if (occurrence in self.custom_occurrences) {
                    // Override only the properties that exist in self.custom_occurrences[occurrence]
                    data = Object.assign(data, self.custom_occurrences[occurrence]);
                }

                // Call the addOrEditOccurrence function to get the edit event form
                let edit_event_form = self.addOrEditOccurrence(data, false);
                let occ_card = parent.closest('.occurrence-card');
                occ_card.insertAdjacentElement('afterend', edit_event_form);
                self.modal.positionModal(); // Position the modal
            });
        });

        return occurrences_form;

    },

    updateModal: function ({update_occurrences = true} = {}) {
        let self = this;

        if (update_occurrences){
            self.generateOccurrences();
        }

        let start_date = document.querySelector(`input[name="${this.config.fields.start}"]`).value || '';
        let end_date = document.querySelector(`input[name="${this.config.fields.end}"]`).value || '';

        let conf = {
            'start_date': start_date,
            'end_date': end_date,
            'until': self.until,
            'expand_accordion': self.occurrences.length == 0,
            'count': self.count
        }
        const modalContent = self.$modalContent[0];

        const repeatruleFreq = modalContent.querySelector('div.repeatrule .freq-rule');
        if (repeatruleFreq) {
            if (self.rule === "WEEKLY"){
                repeatruleFreq.innerHTML = 'Weekly';
            } else if (self.rule === "MONTHLY"){
                repeatruleFreq.innerHTML = 'Monthly';
            } else if (self.rule === "DAILY"){
                repeatruleFreq.innerHTML = 'On Custom Dates';
            }
        }

        const ruleEditPlaceholder = modalContent.querySelector('div.rule-edit-placeholder');
        if (ruleEditPlaceholder) {
            ruleEditPlaceholder.innerHTML = '';
        }

        const addOccurrencePlaceholder = modalContent.querySelector('div.add-occurrence-placeholder');
        if (addOccurrencePlaceholder) {
            addOccurrencePlaceholder.innerHTML = '';
        }

        const occurrences = self.renderOccurrences();

        const occurrencesPlaceholder = modalContent.querySelector('div.event-occurrences-placeholder');
        if (occurrencesPlaceholder) {
            occurrencesPlaceholder.innerHTML = '';
            occurrencesPlaceholder.appendChild(occurrences);
        }

        if (self.rule !== 'DAILY') {
            const compiled_form = _.template(RecurrenceEditTemplate)(conf);
            let recurrence_edit_form = document.createElement('div');
            recurrence_edit_form.innerHTML = compiled_form;

            if (self.occurrences.length === 0){
                recurrence_edit_form.querySelectorAll('div.recurrence-edit-form div#recurrence-action-buttons button').forEach(function(element) {
                    element.removeAttribute('disabled');
                });
            }

            const inputs = recurrence_edit_form.querySelectorAll('input');

            inputs.forEach(input => {
                input.addEventListener('change', function(e) {
                    // Select all buttons within the specified div
                    const buttons = recurrence_edit_form.querySelectorAll('div.recurrence-edit-form div#recurrence-action-buttons button');

                    buttons.forEach(button => {
                        button.removeAttribute('disabled'); // Remove the disabled attribute
                    });

                    if (self.occurrences.length > 0){
                        const recurrence_warning = recurrence_edit_form.querySelector('div.recurrence-edit-form div#recurrence-edit-warning');
                        if (recurrence_warning) {
                            recurrence_warning.style.display = 'block';
                        }
                    }
                });
            });

            if (ruleEditPlaceholder) {
                ruleEditPlaceholder.appendChild(recurrence_edit_form); // Append the new form
            }

            // Save button click event
            const saveButton = recurrence_edit_form.querySelector('button#recurrence-edit-save');
            if (saveButton) {
                saveButton.addEventListener('click', function(e) {
                    e.stopPropagation();
                    self.edit_rule = false;

                    // Get values from the form
                    const rangetype = recurrence_edit_form.querySelector("input[name='rirangetype']:checked")?.value || '';
                    const value = recurrence_edit_form.querySelector("input[name='recurrencerangetypevalue']").value || '';
                    const date_value = recurrence_edit_form.querySelector("input[name='recurrenceuntil']").value || '';

                    if (self.rule !== 'DAILY') {
                        if (rangetype === "BYOCCURRENCES") {
                            self.count = parseInt(value);
                            self.until = "";
                        }
                        if (rangetype === "BYENDDATE") {
                            self.count = 0;
                            self.until = date_value + "T00:00:00.000Z";
                        }
                    } else {
                        self.count = 0;
                        self.until = "";
                    }

                    self.manual_dates = [];
                    self.excluded_dates = [];

                    const recurrence_warning = recurrence_edit_form.querySelector('div.recurrence-edit-form div#recurrence-edit-warning');
                    if (recurrence_warning) {
                        recurrence_warning.style.display = 'none';
                    }

                    recurrence_edit_form.querySelectorAll('div.recurrence-edit-form div#recurrence-action-buttons button').forEach(function(element) {
                        element.setAttribute('disabled', '');
                    });

                    self.generateOccurrences();
                    const occurrences = self.renderOccurrences();

                    const occurrencesPlaceholder = modalContent.querySelector('div.event-occurrences-placeholder');
                    if (occurrencesPlaceholder) {
                        occurrencesPlaceholder.innerHTML = '';
                        occurrencesPlaceholder.appendChild(occurrences);
                    }

                    const toggleButton = recurrence_edit_form.querySelector('#toggleReccurrenceAccordion');
                    toggleButton.click();
                    self.modal.positionModal();
                });
            }

            // Cancel button click event
            const cancelButton = recurrence_edit_form.querySelector('button#recurrence-edit-cancel');
            if (cancelButton) {
                cancelButton.addEventListener('click', function(e) {
                    e.stopPropagation();
                    self.edit_rule = false;

                    const recurrence_warning = recurrence_edit_form.querySelector('div.recurrence-edit-form div#recurrence-edit-warning');
                    if (recurrence_warning) {
                        recurrence_warning.style.display = 'none';
                    }

                    recurrence_edit_form.querySelectorAll('div.recurrence-edit-form div#recurrence-action-buttons button').forEach(function(element) {
                        element.setAttribute('disabled', '');
                    });

                    const toggleButton = recurrence_edit_form.querySelector('#toggleReccurrenceAccordion');
                    toggleButton.click();
                });
            }
        }

        self.modal.positionModal();
    },

    createModal: function () {
        let self = this;
        let config = {
            'rule': self.rule
        }

        const compiled_form = _.template(FormTemplate)(config);
        self.form = document.createElement('div');
        self.form.innerHTML = compiled_form;

        // Append the form to the body
        document.body.appendChild(self.form);

        // Hide the form by setting its display style to 'none'
        self.form.style.display = 'none';

        self.modal = new Modal(self.form, {
            content: "div.edit-form",
            buttons: "div.advancedrecurrence .action-buttons > button",
            modalSizeClass: "modal-xl",
            backdropOptions: {
                closeOnEsc: false,
                closeOnClick: false,
                opacity: "0.5",
            },
        });
    },

    renderDisplay: function (){
        let self = this;
        self.el.parentElement.querySelectorAll('div.event-recurrence').forEach(function(element) {
            element.remove();
        });

        const conf = {
            'rule': self.rule,
            'occurrences': self.occurrences,
            'icons': self.config.icons
        }
        const compiled_form = _.template(DisplayTemplate)(conf);
        const display_form = document.createElement('div');
        display_form.innerHTML = compiled_form;

        const editOccurrences = display_form.querySelector('button#edit-occurrences');
        if (editOccurrences){
            editOccurrences.addEventListener('click', function(e) {
                e.stopPropagation();
                e.preventDefault();
                self.clearValues();
                self.parseRrule();
                self.showModal();
            });
        }

        const selectElement = display_form.querySelector('select#repeatrule');
        if (selectElement) {
            selectElement.addEventListener('change', function(e) {
                self.rule = this.value;
                self.showModal();
            });
        }

        self.el.insertAdjacentElement('afterend', display_form);
    },

    showModal: function (){
        let self = this;
        self.modal.show();
        self.$modalContent = self.modal.$modalContent;
        self.updateModal();
        const modalContent = self.$modalContent[0];

        modalContent.querySelector('button#add-occurrence').addEventListener('click', function(e) {
            let event_format = document.querySelector('input[name="' + self.config.fields.event_format + '"]:checked')?.value || '';
            let venue = document.querySelector('input[name="' + self.config.fields.venue + '"]')?.value || '';
            let address = document.querySelector('input[name="' + self.config.fields.address + '"]')?.value || '';
            let city = document.querySelector('input[name="' + self.config.fields.city + '"]')?.value || '';
            let zip = document.querySelector('input[name="' + self.config.fields.zip + '"]')?.value || '';
            let county = document.querySelector('input[name="' + self.config.fields.county + '"]')?.value || '';
            let link_to_virtual_meeting = document.querySelector('input[name="' + self.config.fields.link_to_virtual_meeting + '"]')?.value || '';
            let no_link = document.querySelector(`input[name="${self.config.fields.no_link}"]`)?.checked || false;

            let data = {
                'occurrence': '',
                'start': '',
                'end': '',
                'event_format': event_format,
                'venue': venue,
                'address': address,
                'city': city,
                'zip': zip,
                'county': county,
                'link_to_virtual_meeting': link_to_virtual_meeting,
                'no_link': no_link
            };

            let add_occurrence_form = self.addOrEditOccurrence(data, false);
            const placeholder = modalContent.querySelector("div.add-occurrence-placeholder");
            placeholder.innerHTML = '';  // Clear previous content
            placeholder.appendChild(add_occurrence_form);
            self.modal.positionModal();
        });

        modalContent.querySelector('div.pattern-modal-buttons button.save-occurrences').addEventListener('click', function(e) {
            e.stopPropagation();
            e.preventDefault();

            let rrule = self.generateRRule();
            self.el.value = rrule;

            let custom_occurrences = JSON.stringify(self.custom_occurrences);
            document.querySelector('textarea[name="' + self.config.fields.custom_occurrences + '"]').value = custom_occurrences;

            self.renderDisplay();
            self.updated = true;
            self.modal.hide();
        });

        // Handle cancel occurrences button click
        modalContent.querySelector('div.pattern-modal-buttons button.cancel-occurrences').addEventListener('click', function(e) {
            self.modal.hide();
            self.clearValues();
            self.parseRrule();
            self.renderDisplay();
        });

    },

    load_icons: async function () {
        return {
            edit: await utils.resolveIcon("pencil-square"),
            remove: await utils.resolveIcon("trash"),
            exclude: await utils.resolveIcon("calendar-x"),
            duplicate: await utils.resolveIcon("copy"),
            video: await utils.resolveIcon("camera-video"),
            pencil: await utils.resolveIcon("pencil-fill"),
            warning: await utils.resolveIcon("exclamation-triangle-fill")
        };
    },

    init: async function () {
        // hide the textarea and the custom_occurrences field
        this.el.style.display = "none";
        document.querySelector('div#formfield-form-widgets-IAdvancedEventRecurrence-custom_occurrences').style.display = 'none';

        this.el.classList.add("advanced-recurrence-widget");

        let icons = await this.load_icons();

        this.config = {
            ...this.options,
            ...this.options.configuration,
            icons: icons,
        };

        this.parseRrule();
        this.renderDisplay();
        this.createModal();

    },
})
